import Vue from "vue";
import vSelect from "vue-select";
import OpenIndicator from '@/components/OpenIndicator'

vSelect.props.components.default = () => ({
  OpenIndicator,
});

Vue.component("v-select", vSelect);